import type {ReactNode} from 'react';
import React from 'react';
import {defineMessage, defineMessages} from 'react-intl';
import {useNavigate} from 'react-router';
import {LayoutQueue} from '@igp/shared/components/layout';
import type {TabData} from '@igp/shared/components/tabs';
import {RoutingTabs} from '@igp/shared/components/tabs';

import {routes} from '@config';

type HomePageLayoutProps = {
    toolbar?: ReactNode;
    body?: ReactNode;
};

const localized = defineMessages({
    transactionHistory: {
        id: 'HomePageLayout_transactionHistory',
        defaultMessage: 'Transaction History',
    },
    revenueShareHistory: {
        id: 'HomePageLayout_revenueShareHistory',
        defaultMessage: 'Revenue Share History',
    },
});

export const noPermissionLocalization = defineMessage({
    id: 'HomePageLayout_noPermissions',
    defaultMessage:
        'This section is only available to agents. {br}Since you are an admin/agent manager, you do not have individual transaction history. {br}Please use the appropriate reporting tools for analysis.',
});

export function HomePageLayout({toolbar, body}: HomePageLayoutProps) {
    const navigate = useNavigate();
    function handleTabOper(path: string) {
        navigate(path);
    }
    const tabs: TabData[] = [
        {
            value: routes.transactionHistory,
            title: localized.transactionHistory,
        },
        {
            value: routes.revenueShareHistory,
            title: localized.revenueShareHistory,
        },
    ];
    return <LayoutQueue header={<RoutingTabs tabs={tabs} onOpenTab={handleTabOper} />} toolbar={toolbar} body={body} />;
}
